var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoLocationCircle = function SvgMoLocationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mo-location-circle_svg__a)",
    d: "M45.72 34c0 6.48-5.25 11.72-11.72 11.72S22.28 40.47 22.28 34 27.53 22.28 34 22.28 45.72 27.53 45.72 34M34 58.624C20.418 58.624 9.376 47.582 9.376 34S20.418 9.376 34 9.376 58.624 20.43 58.624 34H68C68 15.26 52.74 0 34 0S0 15.26 0 34s15.26 34 34 34z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mo-location-circle_svg__a",
    x1: 9.775,
    x2: 59.075,
    y1: 9.775,
    y2: 59.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004EFF"
  })))));
};
export default SvgMoLocationCircle;